<script>
import VDataTableCustom from "@/components/VDataTable/VDataTableCustom.vue";
import NumberFormat from "@/mixins/NumberFormat";

export default {
    name: "VDataTableUsers",
    components: {
        VDataTableCustom,
    },
    mixins: [
        NumberFormat,
    ],
    inheritAttrs: false,
    data: function () {
        return {
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id',
                    width: 100,
                    filterComponent: 'VDataTableCustomHeaderFiltersText',
                    tooltip: 'Идентификатор в системе учета ESS',
                },
                {
                    text: 'E-mail',
                    align: 'start',
                    sortable: true,
                    value: 'email',
                    filterComponent: 'VDataTableCustomHeaderFiltersText',
                    /**
                     * calc(100%/header.size - 50px/header.size)
                     */
                    width: "14.285%"
                },
                {
                    text: 'Фамилия',
                    align: 'start',
                    sortable: true,
                    value: 'last_name',
                    filterComponent: 'VDataTableCustomHeaderFiltersText',
                    width: "14.285%"
                },
                {
                    text: 'Имя',
                    align: 'start',
                    sortable: true,
                    value: 'first_name',
                    filterComponent: 'VDataTableCustomHeaderFiltersText',
                    width: "14.285%"
                },
                {
                    text: 'Должность',
                    align: 'start',
                    sortable: true,
                    value: 'position',
                    filterComponent: 'VDataTableCustomHeaderFiltersText',
                    width: "14.285%"
                },
                {
                    text: 'Компания',
                    align: 'start',
                    sortable: true,
                    value: 'company.name',
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    width: "14.285%"
                },
                {
                    text: 'Роль',
                    align: 'start',
                    sortable: true,
                    value: 'role_name',
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    width: "14.285%"
                },
                {
                    text: 'Активность',
                    align: 'start',
                    sortable: true,
                    value: 'is_active',
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    filterComponentProps: {
                        mapValuesFn: this.prettyBool,
                    },
                    tooltip: 'Активность',
                    //width: "calc(14.285% - 7.14px)"
                },
                {
                    text: 'Создано',
                    align: 'center',
                    sortable: true,
                    value: 'created_at',
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                    width: 120,
                },
                {
                    text: 'Обновлено',
                    align: 'center',
                    sortable: true,
                    value: 'updated_at',
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                    width: 120,
                },
            ],
            sort: {
                by: ["is_active", "last_name"],
                desc: [true, false],
            },
        };
    },
    methods: {
        getItemClass(item) {
            return {
                empty: item?.is_active < 1 ? 'empty' : null,
            }
        },
    },
}
</script>

<template>
    <v-data-table-custom
        v-bind="$attrs"
        v-on="$listeners"
        :headers="headers"
        :item-class="getItemClass"
        :sort-by="sort.by"
        :sort-desc="sort.desc"
        :multi-sort="true"
        item-key="id"
        permissions-by-module="users"
        clear-sort
    >
        <template v-slot:item.is_active="{value}">
            {{ prettyBool(value) }}
        </template>
    </v-data-table-custom>
</template>

<style scoped lang="css">
>>> table tbody tr.empty td {
    color: silver;
    text-decoration: line-through;
}
</style>
